'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';

/**
 * System-level confirmation dialog
 *
 * A reusable dialog for confirming actions with configurable buttons.
 * Similar to window.confirm() but with custom UI and multiple action options.
 *
 * Usage via useConfirmDialog hook:
 *
 * const { confirm } = useConfirmDialog()
 *
 * const result = await confirm({
 *     title: 'Remove Item?',
 *     message: 'What would you like to do?',
 *     buttons: [
 *         { label: 'Remove', action: 'remove', variant: 'primary' },
 *         { label: 'Save for Later', action: 'save', variant: 'secondary' }
 *     ]
 * })
 *
 * if (result === 'remove') { ... }
 * else if (result === 'save') { ... }
 * // result === null means cancelled (X button or background click)
 *
 * Button variants:
 * - 'primary': Main action button (solid primary color)
 * - 'secondary': Alternative action (outlined)
 * - 'danger': Destructive action (red/warning styling)
 */
const ConfirmDialog = t0 => {
  const $ = _c(62);
  const {
    isOpen,
    onClose,
    config
  } = t0;
  const primaryButtonRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useEffect(_temp, t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (primaryButtonRef.current) {
        primaryButtonRef.current.focus();
      }
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleAfterOpen = t2;
  const title = config?.title || "";
  const message = config?.message || "";
  let T0;
  let handleCancel;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== config?.buttons || $[3] !== isOpen || $[4] !== message || $[5] !== onClose || $[6] !== title) {
    const buttons = config?.buttons || [];
    let t18;
    if ($[24] !== onClose) {
      t18 = action => {
        onClose(action);
      };
      $[24] = onClose;
      $[25] = t18;
    } else {
      t18 = $[25];
    }
    const handleButtonClick = t18;
    let t19;
    if ($[26] !== onClose) {
      t19 = () => {
        onClose(null);
      };
      $[26] = onClose;
      $[27] = t19;
    } else {
      t19 = $[27];
    }
    handleCancel = t19;
    const getButtonClasses = _temp2;
    T0 = Modal;
    t10 = isOpen;
    t11 = handleAfterOpen;
    t12 = handleCancel;
    t13 = "fixed top-1/2 left-1/2 right-auto bottom-auto -mr-[50%] -translate-y-1/2 -translate-x-1/2 w-[calc(100%-2rem)] max-w-[400px] rounded-lg bg-white shadow-xl outline-none";
    t14 = "fixed inset-0 outline-none bg-modal-overlay z-[1060] flex items-center justify-center";
    t15 = 200;
    t16 = "ReactModal__Body--open";
    t17 = "ReactModal__Html--open";
    t8 = "relative";
    let t20;
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = <FontAwesomeIcon icon={faXmark} className="text-2xl" />;
      $[28] = t20;
    } else {
      t20 = $[28];
    }
    if ($[29] !== handleCancel) {
      t9 = <button onClick={handleCancel} className="absolute top-4 right-4 text-light hover:text-primary transition-colors z-10" aria-label="Close">{t20}</button>;
      $[29] = handleCancel;
      $[30] = t9;
    } else {
      t9 = $[30];
    }
    t5 = "p-6 pt-5";
    let t21;
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = <FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-xl shrink-0" />;
      $[31] = t21;
    } else {
      t21 = $[31];
    }
    if ($[32] !== title) {
      t6 = <div className="flex items-center gap-3 mb-4 pr-8">{t21}<h2 className="text-lg font-medium text-semi-dark">{title}</h2></div>;
      $[32] = title;
      $[33] = t6;
    } else {
      t6 = $[33];
    }
    if ($[34] !== message) {
      t7 = message && <p className="text-sm text-md mb-6 leading-relaxed">{message}</p>;
      $[34] = message;
      $[35] = t7;
    } else {
      t7 = $[35];
    }
    t3 = "space-y-2";
    t4 = buttons.map((button, index) => <button key={button.action || index} ref={button.variant === "primary" ? primaryButtonRef : null} onClick={() => handleButtonClick(button.action)} className={getButtonClasses(button.variant)}>{button.label}</button>);
    $[2] = config?.buttons;
    $[3] = isOpen;
    $[4] = message;
    $[5] = onClose;
    $[6] = title;
    $[7] = T0;
    $[8] = handleCancel;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t13;
    $[13] = t14;
    $[14] = t15;
    $[15] = t16;
    $[16] = t17;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    T0 = $[7];
    handleCancel = $[8];
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t13 = $[12];
    t14 = $[13];
    t15 = $[14];
    t16 = $[15];
    t17 = $[16];
    t3 = $[17];
    t4 = $[18];
    t5 = $[19];
    t6 = $[20];
    t7 = $[21];
    t8 = $[22];
    t9 = $[23];
  }
  let t18;
  if ($[36] !== t3 || $[37] !== t4) {
    t18 = <div className={t3}>{t4}</div>;
    $[36] = t3;
    $[37] = t4;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  let t19;
  if ($[39] !== handleCancel) {
    t19 = <div className="text-center mt-4"><button onClick={handleCancel} className="text-xs text-light hover:text-dark transition-colors underline">Cancel</button></div>;
    $[39] = handleCancel;
    $[40] = t19;
  } else {
    t19 = $[40];
  }
  let t20;
  if ($[41] !== t18 || $[42] !== t19 || $[43] !== t5 || $[44] !== t6 || $[45] !== t7) {
    t20 = <div className={t5}>{t6}{t7}{t18}{t19}</div>;
    $[41] = t18;
    $[42] = t19;
    $[43] = t5;
    $[44] = t6;
    $[45] = t7;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== t20 || $[48] !== t8 || $[49] !== t9) {
    t21 = <div className={t8}>{t9}{t20}</div>;
    $[47] = t20;
    $[48] = t8;
    $[49] = t9;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== T0 || $[52] !== t10 || $[53] !== t11 || $[54] !== t12 || $[55] !== t13 || $[56] !== t14 || $[57] !== t15 || $[58] !== t16 || $[59] !== t17 || $[60] !== t21) {
    t22 = <T0 isOpen={t10} onAfterOpen={t11} onRequestClose={t12} className={t13} overlayClassName={t14} closeTimeoutMS={t15} bodyOpenClassName={t16} htmlOpenClassName={t17}>{t21}</T0>;
    $[51] = T0;
    $[52] = t10;
    $[53] = t11;
    $[54] = t12;
    $[55] = t13;
    $[56] = t14;
    $[57] = t15;
    $[58] = t16;
    $[59] = t17;
    $[60] = t21;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  return t22;
};
export default ConfirmDialog;
function _temp() {
  Modal.setAppElement("#app");
}
function _temp2(variant) {
  switch (variant) {
    case "primary":
      {
        return "btn btn-sm btn-primary w-full";
      }
    case "danger":
      {
        return "btn btn-sm btn-primary w-full";
      }
    case "secondary":
    default:
      {
        return "btn btn-sm btn-default w-full";
      }
  }
}